import FidcLoteModal from "./fidcLoteModal";
import { exibirNomeProduto } from '../../shared/constantes/nomenclatura';
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useMemo, useState, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import { PropostaDTO } from '../../shared/dto/propostaDTO';
import { format } from 'date-fns';
import Row from 'react-bootstrap/Row';
import { Situacoes } from '../../shared/constantes/situacaoEsteira';
import Col from 'react-bootstrap/Col';
import { Button, Form } from 'react-bootstrap';
import { PontoVendaDTO } from '../../shared/dto/pontoVendaDTO';
import { Promotora } from '../../shared/model/promotora';
import { Originador } from '../../shared/model/originador';
import { Matriz } from '../../shared/model/matriz';
import { Operador } from '../../shared/model/operador';
import { Gerente } from '../../shared/model/gerente';
import { EsteiraModelo } from '../../shared/model/esteira_modelo';
import { SituacoesOpcoes } from '../../shared/constantes/situacaoEsteira';
import { FasesOpcoes } from '../../shared/constantes/fasesEsteira';
import { Produto } from '../../shared/model/produto';
import { FiltroPropostaDTO } from '../../shared/dto/filtroPropostaDTO';
import { Empregador } from '../../shared/model/empregador';
import { getLabelTipoProp, TiposProposta } from '../../shared/constantes/tiposProposta';
import InputMask from 'react-input-mask';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEye, faPrint, faRefresh, faFilter, faThumbsUp, faThumbsDown, faPaperPlane, faPlaneLock, faDatabase, faPhone, faIdCard } from '@fortawesome/free-solid-svg-icons';
import { RotasProcessoEsteira } from '../../shared/rotasProcessoEsteira';
import { AcaoPropostaEnum } from '../../shared/constantes/acaoPropostaEnum';
import { ProcessoPropostaEsteiraEnum } from '../../shared/constantes/processoPropostaEsteiraEnum';
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import ScrollToTopButton from '../../shared/scrollToTopButton';
import ReprovarOuPendenciarPropostaModal from '../../shared/reprovarOuPendenciarPropostaModal';
import PropostaService from '../../services/propostaService';
import MatrizService from '../../services/matrizService';
import PromotoraService from '../../services/promotoraService';
import SupervisorService from '../../services/supervisorService';
import OperadorService from '../../services/operadorService';
import EmpregadorService from '../../services/empregadorService';
import PropostaEsteiraService from '../../services/propostaEsteiraService';
import PontoVendaService from '../../services/pontoVendaService';
import ProdutoService from '../../services/produtoService';
import EsteiraModeloService from '../../services/esteiraModeloService';
import CustomAlert from '../../shared/customAlert';
import styled from 'styled-components';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import ClienteService from '../../services/clienteService'

import { AtividadesDisponiveisDTO } from '../../shared/dto/atividadesDisponiveisDTO';
import { verificarPermissaoFase } from '../../services/validacaoFaseEsteiraService';
import { Role } from '../../shared/model/role';
import UsuarioService from '../../services/usuarioService';
import { Processos } from '../../shared/constantes/processosEsteira';
import OriginadorService from '../../services/originadorService';
import BureauService from '../../services/bureauService';

function PropostasComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [isLoadingEsteira, setIsLoadingEsteira] = useState(false);
  const { tipoTela } = useParams();
  const [propostasDTO, setPropostasDTO] = useState<PropostaDTO[]>([]);
  const situacoesParaFiltro = Situacoes.filter(s => s.value !== "");

  const [filtros, setFiltros] = useState(false);
  const [matriz, setMatriz] = useState('');
  const [matrizes, setMatrizes] = useState<Matriz[]>([]);
  const [promotora, setPromotora] = useState('');
  const [promotoras, setPromotoras] = useState<Promotora[]>([]);

  const [originadorList, setOriginadorList] = useState<Originador[]>([]);
  const [originadorSelecionado, setOriginadorSelecionado] = useState('0');

  const [supervisor, setSupervisor] = useState('');
  const [supervisores, setSupervisores] = useState<Gerente[]>([]);
  const [operador, setOperador] = useState('');
  const [operadores, setOperadores] = useState<Operador[]>([]);
  const [pontoVenda, setPontoVenda] = useState('');
  const [pontoVendas, setPontoVendas] = useState<PontoVendaDTO[]>([]);
  const [esteira, setEsteira] = useState('');
  const [esteiras, setEsteiras] = useState<EsteiraModelo[]>([]);
  const [esteirasDisponiveis, setEsteirasDisponiveis] = useState<EsteiraModelo[]>([]);
  const [esteirasSelecionadas, setEsteirasSelecionadas] = useState<EsteiraModelo[]>([]);
  const situacoesOpcoes = SituacoesOpcoes;
  const [selecionadosSituacao, setSelecionadosSituacao] = useState<String[]>([]);
  const fasesOpcoes = FasesOpcoes;
  const [selecionadosFases, setSelecionadosFases] = useState<String[]>([]);
  const [dataInicio, setDataInicio] = useState<Date | undefined>();
  const [dataFim, setDataFim] = useState<Date | undefined>();
  const [produto, setProduto] = useState('');
  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [tipoProposta, setTipoProposta] = useState('');
  const tiposProposta = TiposProposta;
  const [empregador, setEmpregador] = useState('');
  const [empregadores, setEmpregadores] = useState<Empregador[]>([]);
  const [numeroProposta, setNumeroProposta] = useState('');
  const [cpf, setCpf] = useState('');
  const [nomeCliente, setNomeCliente] = useState('');
  const [celularCliente, setCelularCliente] = useState('');

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [atualizarPag, setAtualizarPag] = useState(false);

  const [pageSize, setPageSize] = useState(20);

  const [ultimoFiltro, setUltimoFiltro] = useState<FiltroPropostaDTO | null>(null);

  const qtdRegistros = [10, 20, 30, 50, 100];

  const [selecionarTudo, setSelecionarTudo] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [selectedMotivo, setSelectedMotivo] = useState('');

  const [atividadesDisponiveis, setAtividadesDisponiveis] = useState<AtividadesDisponiveisDTO[]>([]);
  const [atividadesSelecionados, setAtividadesSelecionados] = useState<AtividadesDisponiveisDTO[]>([]);

  const propostaService: PropostaService = new PropostaService();
  const matrizService: MatrizService = new MatrizService();
  const promotoraService: PromotoraService = new PromotoraService();
  const originadorService: OriginadorService = new OriginadorService();
  const supervisorService: SupervisorService = new SupervisorService();
  const operadorService: OperadorService = new OperadorService();
  const propostaEsteiraService: PropostaEsteiraService = new PropostaEsteiraService();
  const pontoVendaService: PontoVendaService = new PontoVendaService();
  const empregadorService: EmpregadorService = new EmpregadorService();
  const produtoService: ProdutoService = new ProdutoService();
  const esteiraModeloService: EsteiraModeloService = new EsteiraModeloService();
  const usuarioService: UsuarioService = new UsuarioService();

  const [role, setRole] = useState<Role | null>(null);

  const getPropListagem = (item: PropostaDTO) => {
    const numeroPropostaItem = item.numeroProposta?.toString().trim();

    return numeroPropostaItem || '-';
  };

  const service = new BureauService();

  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = (motivo: string) => {
    setSelectedMotivo(motivo);
    setShowModal(false);
    enviaAcaoEmLote(false, motivo);
  };

  const [loteFidc, setLoteFidc] = useState<{ ids: number[]; reprovar: boolean } | null>(null);

  const acaoEmLote = async (isAprovar: boolean) => {
    const selecionadas = propostasDTO.filter(p => p.selected);
    if (!selecionadas.length) {
      setAlert({ message: 'Selecione pelo menos uma proposta.', type: 'warning' }); return;
    }
    if (isAprovar || selecionadas.some(p => p.processoEsteira === 'CONFIRMACAO_FIDC')) {
      setLoteFidc({ ids: selecionadas.map(p => Number(p.id)), reprovar: !isAprovar }); return;
    }
    if (!isAprovar) {
      setShowModal(true);
    } else {
      enviaAcaoEmLote(isAprovar, null);
    }
  };

  const enviaAcaoEmLote = async (isAprovar: boolean, motivo: string | null) => {
    try {
      setLoading(true);
      const acao = isAprovar ? AcaoPropostaEnum.APROVAR : AcaoPropostaEnum.REPROVAR;
      const response = await propostaService.aprovarReprovarEmLote(acao, motivo, propostasDTO);

      setLoading(false);
      setAlert({ message: response.data, type: 'success' });
      setAtualizarPag(!atualizarPag);
    } catch (err: any) {
      setLoading(false);
      console.error(err);
      setAlert({ message: err.response.data, type: 'error' });
    }
  };

  const selecionarDeselecionarTodos = (marcar: boolean) => {
    setSelecionarTudo(marcar);
    const updatedProposta = propostasDTO.map((item) => ({ ...item, selected: marcar }));
    setPropostasDTO(updatedProposta);
  };

  const handleSelecionarChange = (id: any) => {
    if (selecionarTudo) {
      setSelecionarTudo(false);
    }
    setPropostasDTO((prevData) => {
      const updatedProposta = prevData.map((item) =>
        item.id === id ? { ...item, selected: !item.selected } : item
      );
      const todosMarcadosAgora = todosMarcados(updatedProposta);
      setSelecionarTudo(todosMarcadosAgora);

      return updatedProposta;
    });
  };

  const todosMarcados = (proposta: PropostaDTO[]) => {
    return proposta.every((item) => item.selected);
  };

  /*
  const listarTodasPropostas = async (max: number, filtroBool: boolean, filtroManual?: FiltroPropostaDTO) => {
    try {
      setLoading(true);
      let filtro = filtroManual || new FiltroPropostaDTO();

      if (filtroBool && !filtroManual) {
        filtro.matriz = matriz ? [parseInt(matriz)] : [];
        filtro.promotora = parseInt(promotora);
        filtro.supervisor = parseInt(supervisor);
        filtro.operador = parseInt(operador);
        filtro.pontoVenda = parseInt(pontoVenda);
        filtro.esteira = esteirasSelecionadas.map(e => Number(e.id));
        filtro.situacaoEsteira = selecionadosSituacao;
        filtro.faseEsteira = selecionadosFases;
        filtro.atividades = atividadesSelecionados.map(atividade => atividade.atividade);
        filtro.dataInicio = dataInicio!;
        filtro.dataFim = dataFim!;
        filtro.produto = parseInt(produto);
        filtro.tipoProposta = tipoProposta;
        filtro.empregador = parseInt(empregador);
        filtro.numeroProposta = numeroProposta.trim();
        filtro.cpf = cpf;
        filtro.nomeCliente = nomeCliente;
        filtro.celularCliente = celularCliente;
      } else if (!filtroBool) {
        filtro.dataInicio = new Date(new Date().setMonth(new Date().getMonth() - 2));
        filtro.dataFim = new Date();
      }

      setUltimoFiltro(filtro);
setPropostasDTO
      const responseList = await propostaService.listarTodasPropostas(currentPage, max, filtro);

      const jsonList: PropostaDTO[] = responseList.data.content;
      setPropostasDTO(jsonList);
      setTotalPages(responseList.data.totalPages);
      //setLoading(false);
    } catch (err) {
      //setLoading(false);
      console.error(err);
    }
  }; */

  const listarTodasPropostas = async (max: number, filtroBool: boolean, filtroManual?: FiltroPropostaDTO, pageToLoad: number = currentPage) => {
    try {
      setLoading(true);
      let filtro = filtroManual || new FiltroPropostaDTO();

      if (filtroBool && !filtroManual) {
        filtro.matriz = matriz && matriz !== "null" ? [parseInt(matriz)] : [];

        filtro.originador = parseInt(originadorSelecionado) > 0 ? parseInt(originadorSelecionado) : undefined;

        filtro.promotora = parseInt(promotora) > 0 ? parseInt(promotora) : undefined;
        filtro.supervisor = parseInt(supervisor) > 0 ? parseInt(supervisor) : undefined;
        filtro.operador = parseInt(operador) > 0 ? parseInt(operador) : undefined;
        filtro.pontoVenda = parseInt(pontoVenda) > 0 ? parseInt(pontoVenda) : undefined;

        filtro.esteira = esteirasSelecionadas.map(e => Number(e.id));
        filtro.situacaoEsteira = selecionadosSituacao.length > 0 ? selecionadosSituacao : undefined;
        filtro.faseEsteira = selecionadosFases.length > 0 ? selecionadosFases : undefined;
        filtro.atividades = atividadesSelecionados.map(atividade => atividade.atividade);

        filtro.dataInicio = dataInicio || new Date(new Date().setMonth(new Date().getMonth() - 2));
        filtro.dataFim = dataFim || new Date();

        filtro.produto = parseInt(produto) > 0 ? parseInt(produto) : undefined;
        filtro.tipoProposta = tipoProposta !== "0" && tipoProposta !== "" ? tipoProposta : undefined;
        filtro.empregador = parseInt(empregador) > 0 ? parseInt(empregador) : undefined;
        filtro.numeroProposta = numeroProposta.trim() !== "" ? numeroProposta.trim() : undefined;

        filtro.cpf = cpf.replace(/[.-]/g, "").trim() !== "" ? cpf.replace(/[.-]/g, "") : undefined;
        filtro.nomeCliente = nomeCliente.trim() !== "" ? nomeCliente : undefined;
        filtro.celularCliente = celularCliente.replace(/_/g, "").trim() !== "" ? celularCliente : undefined;
      } else if (!filtroBool) {
        filtro.dataInicio = new Date(new Date().setMonth(new Date().getMonth() - 2));
        filtro.dataFim = new Date();
      }

      setUltimoFiltro(filtro);

      let responseList;
      if (tipoTela === 'LOTE') {
        responseList = await propostaService.listarPropostasParaLote(pageToLoad, max, filtro);
      } else {
        responseList = await propostaService.listarTodasPropostas(pageToLoad, max, filtro);
      }

      setPropostasDTO(responseList.data.content);
      setTotalPages(responseList.data.totalPages);

      if (pageToLoad !== currentPage) {
        setCurrentPage(pageToLoad);
      }
    } catch (err) {
      console.error("Erro na listagem:", err);
    } finally {
      setLoading(false);
    }
  };

  const listarMatrizes = async () => {
    try {
      await matrizService.listarTodasMatrizesPorRole()
        .then(resp => {
          setMatrizes(resp.data);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarPromotoras = async (idOriginador?: string) => {
    try {
      let response;
      if (idOriginador && idOriginador !== '0' && idOriginador !== '') {
        response = await promotoraService.buscarPorOriginador([Number(idOriginador)]);
      } else {
        response = await promotoraService.listarTodasPromotorasAtivasPorRole();
      }
      setPromotoras(response.data);
      setPromotora('0');
    } catch (err) {
      console.error("Erro ao carregar promotoras:", err);
    }
  };

  const listarOriginador = async () => {
    try {
      const resp = await originadorService.listarTodasOriginadoresPorRole();
      const lista = resp.data;

      setOriginadorList(lista);

      if (lista && lista.length > 0) {
        const primeiroOriginador = lista[0];
      }
    } catch (err) {
      console.error(err);
    }
  }

  const listarSupervisores = async () => {
    try {
      await supervisorService.listarTodosGerentesPorRole()
        .then(resp => {
          setSupervisores(resp.data);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarOperadores = async () => {
    try {
      await operadorService.listarTodosOperadoresPorRole()
        .then(resp => {
          setOperadores(resp.data);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarPontoVendas = async () => {
    try {
      await pontoVendaService.listarTodosPontosVendasPorRole()
        .then(resp => {
          setPontoVendas(resp.data);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const listarEsteiras = async () => {
    try {
      await esteiraModeloService.listarTodasEsteirasModelo()
        .then(resp => {
          setEsteirasDisponiveis(resp.data);
          setEsteirasSelecionadas([]);
        })
    } catch (err) {
      console.error(err);
    }
  }

  const moverEsteiraParaSelecionadas = () => {
    const selectDisponiveis = document.getElementById('listaEsteirasDisponiveis') as HTMLSelectElement;
    const selectedOptions = Array.from(selectDisponiveis.selectedOptions).map(opt => opt.value);

    const esteirasParaMover = esteirasDisponiveis.filter(esteira =>
      selectedOptions.includes(esteira.id!.toString())
    );

    setEsteirasDisponiveis(esteirasDisponiveis.filter(esteira =>
      !selectedOptions.includes(esteira.id!.toString())
    ));
    setEsteirasSelecionadas([...esteirasSelecionadas, ...esteirasParaMover]);
  };

  const moverEsteiraParaDisponiveis = () => {
    const selectSelecionados = document.getElementById('listaEsteirasSelecionadas') as HTMLSelectElement;
    const selectedOptions = Array.from(selectSelecionados.selectedOptions).map(opt => opt.value);

    const esteirasParaMover = esteirasSelecionadas.filter(esteira =>
      selectedOptions.includes(esteira.id!.toString())
    );

    setEsteirasSelecionadas(esteirasSelecionadas.filter(esteira =>
      !selectedOptions.includes(esteira.id!.toString())
    ));
    setEsteirasDisponiveis([...esteirasDisponiveis, ...esteirasParaMover]);
  };

  const moverTodasEsteirasParaSelecionadas = () => {
    setEsteirasSelecionadas([...esteirasSelecionadas, ...esteirasDisponiveis]);
    setEsteirasDisponiveis([]);
  };

  const moverTodasEsteirasParaDisponiveis = () => {
    setEsteirasDisponiveis([...esteirasDisponiveis, ...esteirasSelecionadas]);
    setEsteirasSelecionadas([]);
  };

  const listarAtividadesDisponiveis = async (idsEsteiras: number[]) => {
    try {
      setLoading(true);

      if (idsEsteiras.length > 0) {
        const todasAtividades: AtividadesDisponiveisDTO[] = [];

        for (const idEsteira of idsEsteiras) {
          try {
            const response = await propostaService.listarAtividadesDisponiveis(idEsteira);
            todasAtividades.push(...response.data);
          } catch (err) {
            console.error(`Erro ao carregar atividades da esteira ${idEsteira}:`, err);
          }
        }

        const atividadesUnicas = todasAtividades.filter((atividade, index, self) =>
          index === self.findIndex(a => a.atividade === atividade.atividade)
        );

        setAtividadesDisponiveis(atividadesUnicas);
        setAtividadesSelecionados([]);
      } else {
        setAtividadesDisponiveis([]);
        setAtividadesSelecionados([]);
      }

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error('Erro ao carregar atividades das esteiras', err);
      setAlert({ message: 'Erro ao carregar atividades das esteiras', type: 'error' });
    }
  }

  const moverParaSelecionados = () => {
    const selectDisponiveis = document.getElementById('listaDisponiveis') as HTMLSelectElement;
    const selectedOptions = Array.from(selectDisponiveis.selectedOptions).map(opt => opt.value);

    const atividadesParaMover = atividadesDisponiveis.filter(atividade =>
      selectedOptions.includes(atividade.atividade.toString())
    );

    setAtividadesDisponiveis(atividadesDisponiveis.filter(atividade =>
      !selectedOptions.includes(atividade.atividade.toString())
    ));
    setAtividadesSelecionados([...atividadesSelecionados, ...atividadesParaMover]);
  };

  const moverParaDisponiveis = () => {
    const selectSelecionados = document.getElementById('listaSelecionados') as HTMLSelectElement;
    const selectedOptions = Array.from(selectSelecionados.selectedOptions).map(opt => opt.value);

    const atividadesParaMover = atividadesSelecionados.filter(atividade =>
      selectedOptions.includes(atividade.atividade.toString())
    );

    setAtividadesSelecionados(atividadesSelecionados.filter(atividade =>
      !selectedOptions.includes(atividade.atividade.toString())
    ));
    setAtividadesDisponiveis([...atividadesDisponiveis, ...atividadesParaMover]);
  };

  const moverTodosParaSelecionados = () => {
    setAtividadesSelecionados([...atividadesSelecionados, ...atividadesDisponiveis]);
    setAtividadesDisponiveis([]);
  };

  const moverTodosParaDisponiveis = () => {
    setAtividadesDisponiveis([...atividadesDisponiveis, ...atividadesSelecionados]);
    setAtividadesSelecionados([]);
  };

  const listarProdutos = async () => {
    try {
      const response = await produtoService.listarTodosProdutos();

      if (response.status === 200) {
        if (Array.isArray(response.data)) {
          setProdutos(response.data);
        } else if (response.data.content) {
          setProdutos(response.data.content);
        } else {
          setProdutos([]);
        }
      }
    } catch (err: any) {
      console.error('Erro ao carregar produtos:', err);
      setProdutos([]);
      setAlert({ message: 'Erro ao carregar produtos', type: 'error' });
    } finally {
    }
  }

  const listarEmpregadores = async () => {
    try {
      await empregadorService.listarTodosEmpregadores()
        .then(resp => {
          setEmpregadores(resp.data);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const handleCheckboxChangeSituacao = (opcao: string) => {
    if (selecionadosSituacao.includes(opcao)) {
      setSelecionadosSituacao(selecionadosSituacao.filter(item => item !== opcao));
    } else {
      setSelecionadosSituacao([...selecionadosSituacao, opcao]);
    }
  };

  const handleCheckboxChangeFases = (op: string) => {
    if (selecionadosFases.includes(op)) {
      setSelecionadosFases(selecionadosFases.filter(item => item !== op));
    } else {
      setSelecionadosFases([...selecionadosFases, op]);
    }
  };

  const gerarRelatorioProposta = async (idProposta: number) => {
    setLoading(true);
    try {
      await propostaService.listarPropostaEspelhoJasper(idProposta)
        .then(resp => {
          const blob = new Blob([resp.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          window.open(url);
          setLoading(false);
        })
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }

  const propostasComMesmoCpfTelefone = async (cpf: string, celularCliente: string) => {
    setCpf(cpf);
    let filtro = new FiltroPropostaDTO();
    filtro.cpf = cpf;
    filtro.celularCliente = celularCliente;

    const responseList = await propostaService.listarTodasPropostas(currentPage, pageSize, filtro);

    const jsonList: PropostaDTO[] = responseList.data.content;
    setPropostasDTO(jsonList);
    setTotalPages(responseList.data.totalPages);
  }

  const direcionamentoProcessoEsteira = async (processo: string, idCliente: string, idProposta: string) => {

    if (isLoadingEsteira) {
      return;
    }

    setIsLoadingEsteira(true);
    setLoading(true);

    try {
      const temPermissao = await verificarPermissaoFase(idProposta);

      if (!temPermissao) {

        setAlert({
          message: "Você não possui permissão para acessar esta fase da proposta.",
          type: 'error'
        });
        setIsLoadingEsteira(false);
        setLoading(false);
        return;
      }
    } catch (error) {
      setAlert({
        message: "Você não possui permissão para acessar esta fase da proposta.",
        type: 'error'
      });
      setIsLoadingEsteira(false);
      setLoading(false);
      return;
    }

    if (tipoTela === 'LOTE') {
      setLoading(false);
      return;
    }

    let serasaAut: boolean = true;


    if (processo === ProcessoPropostaEsteiraEnum.VALID_SERASA) {
      serasaAut = await service.consultarPassivelDeAnalise(Number(idProposta));
    }

    if (processo === ProcessoPropostaEsteiraEnum.APR_PROP_AUT || serasaAut === false) {
      setLoading(false);
      aprovarProposta(idProposta, processo);
    } else {
      const route = RotasProcessoEsteira.find(route => route.label === processo);
      if (route && route.value && route.value != 'BACKEND') {
        const url = route.value
          .replace('{idCliente}', idCliente)
          .replace('{idProposta}', idProposta);
        const routeTempelte = JSON.parse(url);
        const newState = {
          ...routeTempelte.state,
          processoEsteira: processo
        };
        setLoading(false);
        navigate(routeTempelte.path, { state: newState });
      } else {
        setLoading(false);
        aprovarProposta(idProposta, processo);
      }
    }
    setIsLoadingEsteira(false);
    setLoading(false);
  };

  const aprovarProposta = async (idProposta: string, processo: string) => {
    if (processo === null || processo.length === 0) {
      processo = 'SEM_PROCESSO';
    }
    setLoading(true);
    try {
      await propostaEsteiraService.incluirPropostaEsteiraComExecucao(idProposta, AcaoPropostaEnum.APROVAR, processo, null)
        .then(resp => {
          setLoading(false);
          setAtualizarPag(!atualizarPag);
        })
      if (processo === 'AVERBACAO_RMC') {
        setAlert({ message: "Proposta averbada com sucesso", type: 'success' });
      } else if (processo === 'BPO_INC_FORM_DIG') {
        setAlert({ message: "Proposta enviada para formalização!", type: 'success' });
      }
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response.data, type: err.response.data.startsWith('Proposta em formalização') ? 'warning' : 'error' });
      console.error(err);
    }
  };

  const listarUsuarioPorId = async () => {
    setLoading(true);
    try {
      const id = localStorage.getItem("id") ?? "";
      const response = await usuarioService.listarUsuarioComOrigemPorId(id);
      const json = response.data[0].usuario;

      setRole(json.role);

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
      console.error(err);
    }
  };


  const isPassivel = async (idProposta: number) => {
    try {
      const response = await service.consultarPassivelDeAnalise(Number(idProposta));


      return response
    } catch (err: any) {
      setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
      console.error(err);
    }
  };


  // Adicione este useEffect para carregar atividades quando as esteiras selecionadas mudarem
  /*
  useEffect(() => {
    if (esteirasSelecionadas.length > 0) {
      // Se houver apenas uma esteira selecionada, carrega suas atividades
      if (esteirasSelecionadas.length === 1) {
        // Converte o ID para número (caso seja string)
        const esteiraId = Number(esteirasSelecionadas[0].id);
        listarAtividadesDisponiveis(esteiraId);
      } else {
        // Se houver múltiplas esteiras selecionadas, limpe as atividades
        setAtividadesDisponiveis([]);
        setAtividadesSelecionados([]);
      }
    } else {
      // Se não houver esteiras selecionadas, limpe as atividades
      setAtividadesDisponiveis([]);
      setAtividadesSelecionados([]);
    }
  }, [esteirasSelecionadas]);
  */

  useEffect(() => {
    listarPromotoras(originadorSelecionado);
  }, [originadorSelecionado]);

  useEffect(() => {
    listarUsuarioPorId();
    if (esteirasSelecionadas.length > 0) {
      const esteirasIds = esteirasSelecionadas.map(esteira => Number(esteira.id));
      listarAtividadesDisponiveis(esteirasIds);
    } else {
      setAtividadesDisponiveis([]);
      setAtividadesSelecionados([]);
    }
  }, [esteirasSelecionadas]);

  useEffect(() => {
    //setPropostasDTO([]);
    //setDataInicio(new Date(new Date().setMonth(new Date().getMonth() - 2)));
    //setDataFim(new Date());

    if (ultimoFiltro) {
      listarTodasPropostas(pageSize, true, ultimoFiltro);
    } else {
      listarTodasPropostas(pageSize, false);
    }

    listarMatrizes();
    //listarPromotoras();
    listarOriginador();
    listarSupervisores();
    listarOperadores();
    listarPontoVendas();
    listarEsteiras();
    listarProdutos();
    listarEmpregadores();
  }, [currentPage, atualizarPag, filtros, ultimoFiltro]);

  const ultimoErroExibidoId = useRef<number | null>(null);

  const propostaComErro = useMemo(() => {
    return propostasDTO.find(
      p =>
        (p.processoEsteira === 'VALID_PH3A_BASICA' || p.processoEsteira === 'VALID_PH3A_PROCESSOS') &&
        p.erro_proposta
    );
  }, [propostasDTO]);

  useEffect(() => {
    if (!propostaComErro) {
      ultimoErroExibidoId.current = null;
      return;
    }

    if (propostaComErro.id !== ultimoErroExibidoId.current) {
      setAlert({
        message: `A requisição da proposta ${propostaComErro.numeroProposta || '-'} à integração retornou o erro: ${propostaComErro.erro_proposta}`,
        type: 'error'
      });

      ultimoErroExibidoId.current = propostaComErro.id;
    }

  }, [propostaComErro]);

  const propostaCongelada = useMemo(
    () =>
      propostasDTO.find(
        p =>
          (p.processoEsteira === 'VALID_PH3A_BASICA' || p.processoEsteira === 'VALID_PH3A_PROCESSOS') &&
          p.propostaCongelada === true
      ),
    [propostasDTO]
  );

  useEffect(() => {
    if (!propostaCongelada) return;

    const interval = setInterval(async () => {
      try {
        const response = await propostaService.listarPropostaParaReprovacao(
          propostaCongelada.id.toString()
        );

        const congeladaBackend = response.data?.propostaCongelada;

        if (typeof congeladaBackend !== 'boolean') return;

        setPropostasDTO(prev =>
          prev.map(p =>
            p.id === propostaCongelada.id
              ? {
                ...p,
                propostaCongelada: congeladaBackend,
                atividadeAtual: response.data.atividadeAtual ?? p.atividadeAtual,
                processoEsteira: response.data.processoEsteira ?? p.processoEsteira

              }
              : p
          )
        );
      } catch (e) {
        console.error("Erro ao atualizar proposta congelada", e);
      }
    }, 4000);

    return () => clearInterval(interval);
  }, [propostaCongelada]);
  const getStatusColor = (status: string) => {
    switch (status) {
      case "CAD": return "#D3D3D3";
      case "AND": return "#00BFFF";
      case "PEN": return "#FFFF00";
      case "APR": return "#228B22";
      case "LIB": return "#228B22";
      case "PAG": return "#228B22";
      case "INT": return "#1E90FF";
      case "REP": return "#FF0000";
      default: return "transparent";
    }
  };

  return (
    <div className="position-relative m-md-1">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      <div style={{ marginBottom: '15px', display: 'flex', justifyContent: 'space-between' }}>
        <h5>Esteira &gt; Cartão Consignado</h5>
      </div>

      <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
        <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
          <FontAwesomeIcon icon={faFilter} style={{ marginRight: '10px' }} />
          Filtros
        </Button>
        <Button id="App-button-cor-principal-escura" onClick={() => listarTodasPropostas(pageSize, true)}>
          <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '10px' }} />
          Atualizar Esteira
        </Button>
      </div>
      {filtros ?
        <>
          <Row className="mb-3">
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Matriz</Form.Label>
              <select className="form-select"
                onChange={(e) => {
                  setMatriz(e.target.value);
                }}
              >
                <option value="null">Selecione uma opção</option>
                {matrizes.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelectOriginador">
              <Form.Label>{Originador.DESCRITIVO_GERAL}</Form.Label>
              <select
                className="form-select"
                value={originadorSelecionado}
                onChange={(e) => setOriginadorSelecionado(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {originadorList.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Promotora</Form.Label>
              <select className="form-select"
                defaultValue={promotora} value={promotora} onChange={(e) => setPromotora(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {promotoras.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Supervisor</Form.Label>
              <select className="form-select"
                defaultValue={supervisor} value={supervisor} onChange={(e) => setSupervisor(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {supervisores.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Operador</Form.Label>
              <select className="form-select"
                defaultValue={operador} value={operador} onChange={(e) => {
                  setOperador(e.target.value);
                }}
              >
                <option value="0">Selecione uma opção</option>
                {operadores.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Ponto de Venda</Form.Label>
              <select className="form-select"
                defaultValue={pontoVenda} value={pontoVenda} onChange={(e) => setPontoVenda(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {pontoVendas.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Row} className="w-100">
              <Col md={5}>
                <Form.Label>Esteiras Disponíveis</Form.Label>
                <Form.Control
                  as="select"
                  multiple
                  id="listaEsteirasDisponiveis"
                  htmlSize={5}
                  style={{ maxWidth: '100%' }}
                >
                  {esteirasDisponiveis.map((esteira) => (
                    <option key={esteira.id} value={esteira.id!}>
                      {esteira.id + ' - ' + esteira.nomeEsteira}
                    </option>
                  ))}
                </Form.Control>
              </Col>

              <Col md={2} className="d-flex flex-column justify-content-center align-items-center gap-2">
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverEsteiraParaSelecionadas()}
                >{'>'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverEsteiraParaDisponiveis()}
                >{'<'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverTodasEsteirasParaSelecionadas()}
                >{'>>'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverTodasEsteirasParaDisponiveis()}
                >{'<<'}</Button>
              </Col>

              <Col md={5}>
                <Form.Label>Esteiras Selecionadas</Form.Label>
                <Form.Control
                  as="select"
                  multiple
                  id="listaEsteirasSelecionadas"
                  htmlSize={5}
                  style={{ maxWidth: '100%' }}
                >
                  {esteirasSelecionadas.map((esteira) => (
                    <option key={esteira.id} value={esteira.id!}>
                      {esteira.id + ' - ' + esteira.nomeEsteira}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Form.Group>
          </Row>

          <Row>
            <Form.Group as={Row} className="w-100">
              <Col md={5}>
                <Form.Label>Atividades Disponíveis</Form.Label>
                <Form.Control
                  as="select"
                  multiple
                  id="listaDisponiveis"
                  htmlSize={15}
                  style={{ maxWidth: '100%' }}
                  disabled={esteirasSelecionadas.length === 0}
                >
                  {esteirasSelecionadas.length === 0 ? (
                    <option>Selecione uma esteira primeiro</option>
                  ) : (
                    atividadesDisponiveis.map((atividade, index) => (
                      <option key={index} value={atividade.atividade}>
                        {atividade.atividade}
                      </option>
                    ))
                  )}
                </Form.Control>
              </Col>

              <Col md={2} className="d-flex flex-column justify-content-center align-items-center gap-2">
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverParaSelecionados()}
                  disabled={esteirasSelecionadas.length === 0}
                >{'>'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverParaDisponiveis()}
                  disabled={esteirasSelecionadas.length === 0}
                >{'<'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverTodosParaSelecionados()}
                  disabled={esteirasSelecionadas.length === 0}
                >{'>>'}</Button>
                <Button
                  variant="secondary"
                  type="button"
                  style={{ width: '40px' }}
                  onClick={() => moverTodosParaDisponiveis()}
                  disabled={esteirasSelecionadas.length === 0}
                >{'<<'}</Button>
              </Col>

              <Col md={5}>
                <Form.Label>Atividades Selecionadas</Form.Label>
                <Form.Control
                  as="select"
                  multiple
                  id="listaSelecionados"
                  htmlSize={15}
                  style={{ maxWidth: '100%' }}
                  disabled={esteirasSelecionadas.length === 0}
                >
                  {atividadesSelecionados.map((atividade, index) => (
                    <option key={index} value={atividade.atividade}>
                      {atividade.atividade}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Form.Group>

            {/* Área dos checkboxes separada por uma nova Row */}
            <Row className="mt-4">
              {/* Situação Proposta */}
              <Col md={6}>
                <Form.Label>Situação Proposta:</Form.Label>
                <div className="d-flex flex-wrap">
                  {situacoesParaFiltro.map((item, index) => (
                    <div key={index} className="me-3">
                      <Form.Check
                        type="checkbox"
                        id={`situacao-${index}`}
                        label={item.label}
                        value={item.value}
                        checked={selecionadosSituacao.includes(item.value)}
                        onChange={() => handleCheckboxChangeSituacao(item.value)}
                      />
                    </div>
                  ))}
                </div>
              </Col>

              {/* Fase */}
              <Col md={6}>
                <Form.Label>Fase:</Form.Label>
                <div className="d-flex flex-wrap">
                  {fasesOpcoes.map((op, index) => (
                    <div key={index} className="me-3">
                      <Form.Check
                        type="checkbox"
                        id={`fase-${index}`}
                        label={op}
                        value={op}
                        checked={selecionadosFases.includes(op)}
                        onChange={() => handleCheckboxChangeFases(op)}
                      />
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Row>
          <Row style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
            <Form.Group as={Col} md='4'>
              <Form.Label>Data de Início:</Form.Label>
              <Form.Control
                type="date"
                value={dataInicio ? dataInicio.toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  if (e.target.value) {
                    setDataInicio(new Date(e.target.value));
                  } else {
                    setDataInicio(undefined);
                  }
                }}
              />
            </Form.Group>
            <Form.Group as={Col} md='1' style={{ display: 'flex', marginTop: '30px', width: '1%' }}>
              <label>a</label>
            </Form.Group>
            <Form.Group as={Col} md='4'>
              <Form.Label>Data de Fim:</Form.Label>
              <Form.Control
                type="date"
                value={dataFim ? dataFim.toISOString().split('T')[0] : ''}
                onChange={(e) => {
                  if (e.target.value) {
                    setDataFim(new Date(e.target.value));
                  } else {
                    setDataFim(undefined);
                  }
                }}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3" style={{ marginTop: '15px' }}>
            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Produto</Form.Label>
              <select className="form-select"
                onChange={(e) => {
                  setProduto(e.target.value);
                }}
              >
                <option value="0">Selecione uma opção</option>
                {produtos.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + exibirNomeProduto(item.nome)}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Tipo Proposta</Form.Label>
              <select className="form-select"
                defaultValue={tipoProposta} value={tipoProposta} onChange={(e) => setTipoProposta(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {tiposProposta.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Empregador</Form.Label>
              <select className="form-select"
                defaultValue={empregador} value={empregador} onChange={(e) => setEmpregador(e.target.value)}
              >
                <option value="0">Selecione uma opção</option>
                {empregadores.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nome}
                  </option>
                ))}
              </select>
            </Form.Group>
          </Row>

          <Row className="mb-4" style={{ marginTop: '15px' }}>
            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Form.Label>Nº Proposta</Form.Label>
              <input type="text" className="form-control" value={numeroProposta} onChange={(e) => setNumeroProposta(e.target.value)} />
            </Form.Group>

            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Form.Label>CPF</Form.Label>
              <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpf} onChange={(e) => setCpf(e.target.value)} />
            </Form.Group>

            <Form.Group as={Col} md='4' controlId="formBasicSelect">
              <Form.Label>Nome Cliente</Form.Label>
              <input type="text" className="form-control" value={nomeCliente} onChange={(e) => setNomeCliente(e.target.value)} />
            </Form.Group>

            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Form.Label>Celular Cliente</Form.Label>
              <InputMask mask="(99)99999-9999" type="text" className="form-control"
                value={celularCliente} onChange={(e) => setCelularCliente((e.target.value).replace(/_/g, ""))}
              />
            </Form.Group>

          </Row>

          <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between' }}>
            <Button id="App-button-cor-principal-escura" onClick={() => setFiltros(!filtros)}>
              <FontAwesomeIcon icon={faFilter} style={{ marginRight: '1px' }} />
            </Button>
            <Button id="App-button-cor-principal-escura" onClick={() => listarTodasPropostas(pageSize, true)}>
              <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '1px' }} />
            </Button>
          </div>
        </>
        : null}

      {loading ? <Spinner loading={loading} /> : (
        <>
          <Row style={{ justifyContent: 'center' }} className="mb-3">
            <Form.Group style={{ marginTop: '10px' }} as={Col} md='2' controlId="formBasicSelect">Registros Por Página</Form.Group>
            <Form.Group as={Col} md='1' controlId="formBasicSelect">
              <select className="form-select"
                defaultValue={pageSize} value={pageSize} onChange={(e) => {
                  {
                    setPageSize(parseInt(e.target.value));
                    listarTodasPropostas(parseInt(e.target.value), true);
                  }
                }}
              >
                {qtdRegistros.map((qtd, index) => (
                  <option key={index} value={qtd}>{qtd}</option>
                ))}
              </select>
            </Form.Group>
            <Form.Group as={Col} md='2' controlId="formBasicSelect">
              <Button
                id="App-button-cor-principal-escura"
                onClick={() => {
                  setFiltros(false);
                  setCurrentPage(0);
                  setUltimoFiltro(null);
                }}
              >
                <FontAwesomeIcon icon={faRefresh} style={{ marginRight: '5px' }} />
                Sem filtros
              </Button>
            </Form.Group>
          </Row>
          <div className="table-responsive m-md">
            <table id="App-reponsive-text" border={3} className="table table-bordered table-striped" style={{ width: '100%', padding: '2px 4px' }}>
              <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                <tr className="GridHeaderStyle">
                  {tipoTela === 'LOTE' ?
                    <th scope="col" id="App-header-table" style={{ width: '1%', textAlign: 'center' }}><input type="checkbox"
                      checked={selecionarTudo} onChange={() => selecionarDeselecionarTodos(!selecionarTudo)}
                    /></th> : null}
                  <th scope="col" id="App-header-table">Sit</th>
                  <th scope="col" id="App-header-table">Prop</th>
                  <th scope="col" id="App-header-table">Contrato</th>
                  <th scope="col" id="App-header-table">Produto</th>
                  <th scope="col" id="App-header-table">Tipo Proposta</th>
                  <th scope="col" id="App-header-table">Promotora</th>
                  <th scope="col" id="App-header-table">Empregador</th>
                  <th scope="col" id="App-header-table">CPF/CNPJ</th>
                  <th scope="col" id="App-header-table">Matricula</th>
                  <th scope="col" id="App-header-table">Cliente</th>
                  <th scope="col" id="App-header-table">RMC</th>
                  <th scope="col" id="App-header-table">Valor Saque</th>
                  <th scope="col" id="App-header-table">Parcela</th>
                  <th scope="col" id="App-header-table">Prazo Saque</th>
                  <th scope="col" id="App-header-table">Digitador</th>
                  <th scope="col" id="App-header-table">Atividade</th>
                  <th scope="col" id="App-header-table">Dt Mov</th>
                  <th scope="col" id="App-header-table">Ações</th>
                </tr>
              </thead>
              <tbody>
                {propostasDTO.map((item) => (
                  <tr className="GridRowStyle">
                    {tipoTela === 'LOTE' ? <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center', height: '100%' }}><input type="checkbox" checked={item.selected} onChange={() => handleSelecionarChange(item.id)} /></td> : null}
                    <td style={{ backgroundColor: getStatusColor(item.statusProposta), display: 'table-cell', verticalAlign: 'middle', textAlign: 'center', height: '100%' }}>
                      <Link to={`/esteira-proposta/atividades`} state={{ idProposta: item.id }} style={{ color: 'black', fontWeight: 'bold', textDecoration: 'none', display: 'inlie-block' }}>
                        {item.statusProposta}
                      </Link>
                    </td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{getPropListagem(item)}</td>

                    {process.env.REACT_APP_PERFIL === 'ALVOCARD' ?
                      <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.numeroContratoExterno ? item.numeroContratoExterno : item.numeroContrato ? item.numeroContrato : '-'}</td>
                      :
                      <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.numeroContrato ? item.numeroContrato : '-'}</td>
                    }

                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{exibirNomeProduto(item.produto)}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{getLabelTipoProp(item.tipoProposta)}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.promotora}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.empregador}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.cpfCliente}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.matriculaCliente}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.nomeCliente}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                      {(item.valorRMCUtilizado ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                      {(item.limiteSaque ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                      {(item.pmt ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.prazo}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>{item.usuario}</td>
                    <td style={{ display: 'table-cell', verticalAlign: 'middle', textAlign: 'center' }}>
                      {tipoTela === 'LOTE' ? (
                        <>
                          {item.atividadeAtual}
                          {item.statusFormalizacao && (
                            <>
                              <br />
                              <span
                                style={{
                                  fontSize: '0.8em',
                                  color: item.isSucessoAtualizacaoForm ? 'green' : 'red',
                                  textDecoration: 'none',
                                  textDecorationColor: item.isSucessoAtualizacaoForm ? 'green' : 'red'
                                }}
                              >
                                {' (' + item.statusFormalizacao + ')'}
                              </span>
                            </>
                          )}
                        </>
                      ) : (
                        (() => {
                          // 🔍 Recupera o processo no enum
                          const processo = Processos.find(p => p.value === item.processoEsteira);
                          const tipoAcessoProcesso = processo?.tipoAcesso || "EXTERNO";
                          const isPH3ACongelado =
                            (item.processoEsteira === 'VALID_PH3A_BASICA' || item.processoEsteira === 'VALID_PH3A_PROCESSOS' || item.processoEsteira === 'CONSULTA_CONTRATO') &&
                            item.propostaCongelada === true;
                          let disabled = false;

                          if (role?.tipoAcesso !== "INTERNO" && tipoAcessoProcesso !== "AMBOS") {
                            disabled = true;
                          }

                          if (isPH3ACongelado) {
                            disabled = true;
                          }

                          return (
                            <button
                              onClick={() => {
                                if (!disabled) {
                                  direcionamentoProcessoEsteira(
                                    item.processoEsteira,
                                    item.idCliente.toString(),
                                    item.id.toString()
                                  );
                                }
                              }}
                              disabled={disabled}
                              style={{
                                border: 'none',
                                background: 'none',
                                color: disabled ? 'gray' : 'blue',
                                textAlign: 'center',
                                cursor: disabled ? 'not-allowed' : 'pointer'
                              }}
                              type="button"
                            >
                              {item.atividadeAtual && (
                                <span
                                  style={{
                                    border: 'none',
                                    textDecoration: disabled ? 'none' : 'underline',
                                    background: 'none',
                                    color: disabled ? 'gray' : 'blue',
                                    textAlign: 'center'
                                  }}
                                >
                                  {item.atividadeAtual}
                                </span>
                              )}

                              {item.statusFormalizacao &&
                                item.processoEsteira.startsWith('BPO_INC_FORM_DIG') && (
                                  <>
                                    <br />
                                    <span
                                      style={{
                                        fontSize: '0.8em',
                                        color: item.isSucessoAtualizacaoForm ? 'green' : 'red',
                                        textDecoration: 'none',
                                        textDecorationLine: 'none',
                                        textDecorationColor: item.isSucessoAtualizacaoForm
                                          ? 'green'
                                          : 'red'
                                      }}
                                    >
                                      {' (' + item.statusFormalizacao + ')'}
                                    </span>
                                  </>
                                )}


                              {item.processoEsteira.startsWith('VALID_SERASA') && (
                                <>
                                  <br />
                                  <span
                                    style={{
                                      fontSize: '0.8em',
                                      color: 'red',
                                      textDecoration: 'none',
                                      textDecorationLine: 'none',
                                      textDecorationColor: 'red'
                                    }}
                                  >
                                    {' ( Alterar Documento para validação! )'}
                                  </span>
                                </>
                              )}
                            </button>
                          );
                        })()
                      )}
                    </td>
                    <td style={{ textAlign: 'center' }}>{item.dtMovimentacao ? format(new Date(item.dtMovimentacao), 'dd/MM/yyyy HH:mm') : ''}</td>
                    <td>
                      <div style={{ display: 'flex' }}>
                        {item.processoEsteira &&
                          (
                            item.processoEsteira.startsWith('BPO_INC_FORM_DIG') ||
                            item.processoEsteira.startsWith('BPO_INC_FORM_UNICO')
                          ) ? (
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey' }} title='Link de Formalização'
                            onClick={() => setAlert({ message: item.linkFormalizacao ? item.linkFormalizacao : 'Link não disponível', type: 'warning' })}>
                            <FontAwesomeIcon size="2xs" icon={faPaperPlane} />
                          </Button>
                        ) : (
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey' }}>
                            <FontAwesomeIcon size="2xs" icon={faPaperPlane} style={{ color: 'black' }} />
                          </Button>
                        )}

                        <Link
                          to={`/esteira-cliente/alteracao`}
                          state={{
                            idCliente: item.idCliente,
                            edicao: 'edicao',
                            idProposta: item.id,
                            atualizacaoCadastro: 'false',
                            processoEsteira: item.processoEsteira
                          }}
                        >
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Cliente'>
                            <FontAwesomeIcon size="2xs" icon={faUser} />
                          </Button>
                        </Link>

                        <Link to={`/proposta-esteira-component`} state={{ idProposta: item.id, esteira: 'N' }}>
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Proposta'>
                            <FontAwesomeIcon size="2xs" icon={faEye} />
                          </Button>
                        </Link>
                        <a onClick={() => gerarRelatorioProposta(item.id)}>
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Relatório'>
                            <FontAwesomeIcon size="2xs" icon={faPrint} />
                          </Button>
                        </a>
                        <a onClick={() => propostasComMesmoCpfTelefone(item.cpfCliente, '')}>
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Propostas com mesmo CPF'>
                            <FontAwesomeIcon size="2xs" icon={faIdCard} />
                          </Button>
                        </a>
                        <a onClick={() => propostasComMesmoCpfTelefone('', item.telefoneCelular)}>
                          <Button className="btn btn-sm" style={{ background: 'grey', border: 'grey', marginLeft: '5px' }} title='Propostas com mesmo Celular'>
                            <FontAwesomeIcon size="2xs" icon={faPhone} />
                          </Button>
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ResponsivePagination
            current={currentPage}
            total={totalPages}
            onPageChange={setCurrentPage} />
          <ScrollToTopButton />
          {tipoTela === 'LOTE' ? (
            <>
              <br />
              <div className="row justify-content-center mt-3">
                <div className="col-auto">
                  <button className="btn btn-success" onClick={() => acaoEmLote(true)}>
                    <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                    Aprovar Propostas
                  </button>
                </div>
                <div className="col-auto">
                  <button className="btn btn-danger" onClick={() => acaoEmLote(false)}>
                    <FontAwesomeIcon icon={faThumbsDown} className="me-2" />
                    Reprovar Propostas
                  </button>
                </div>
              </div>

              {loteFidc && <FidcLoteModal ids={loteFidc.ids} reprovar={loteFidc.reprovar} onHide={() => setLoteFidc(null)}
                onProcessed={resultado => { setLoteFidc(null); setAlert({ message: resultado, type: 'success' }); setAtualizarPag(!atualizarPag); }} />}
              <ReprovarOuPendenciarPropostaModal
                showModal={showModal}
                handleModalCancel={handleModalCancel}
                handleModalConfirm={handleModalConfirm}
                tipoPendenciaRecusa={"R"} />
            </>
          ) : null}
        </>
      )}
    </div>
  );
}

const ResponsiveText = styled.div`
font-size: 12px;

@media (max-width: 1280px) {
  font-size: 8px;
}
`;

export default PropostasComponent;
